// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__30-eD","title":"ClientReferral_title__2pP73","itemText":"ClientReferral_itemText__2ND4p"};